import React from 'react';
import { FormattedMessage } from 'react-intl';
import { trackEcommerce } from 'dibs-tracking';
import LazyLoad from 'react-lazy-load';

// Components
import { Visibility } from '../../components/global/Visibility';
import { hasRecentlyViewedItems, getRecentlyViewedItems } from '../../utils/recentHistory';

// Styles
import styles from './SbRespRecentlyViewed.scss';

// constants
import {
    VERTICAL_OFFSET_RESP_IMG,
    HORIZONTAL_OFFSET_RESP_IMG,
} from '../../constants/imageConstants';

const MAX_RECENT_ITEMS = 5;
const recentItems = getRecentlyViewedItems({ maxItems: MAX_RECENT_ITEMS });
const LIST_TRACKING = 'recent items history';

const getProductData = ({ index, item = {} }) => {
    const {
        category,
        dealerPk,
        contemporaryTrackingString,
        itemId,
        itemCategoryCode,
        itemTitle,
    } = item;

    return {
        id: itemId,
        name: itemTitle || 'n/a',
        position: index,
        brand: dealerPk,
        category,
        categoryCode: itemCategoryCode,
        dimension83: contemporaryTrackingString,
        list: LIST_TRACKING,
    };
};

export class SbRespRecentlyViewed extends React.Component {
    trackProductImpression() {
        const products = recentItems.map((item, index) => getProductData({ item, index }));
        trackEcommerce({ type: 'productImpression', products });
    }

    trackEcommerceProductClick({ item, index }) {
        trackEcommerce({
            type: 'productClick',
            actionField: {
                list: LIST_TRACKING,
            },
            products: [getProductData({ item, index })],
        });
    }

    render() {
        if (!hasRecentlyViewedItems({})) {
            return null;
        }

        return (
            <div className={styles.container} data-tn="recently-viewed-wrapper">
                <Visibility onContentVisible={this.trackProductImpression} />
                <span className={styles.title} data-tn="recently-viewed-title">
                    <FormattedMessage
                        id="sb.SbRespRecentlyViewed.recentlyViewed"
                        defaultMessage="Your Recent History"
                    />
                </span>
                {recentItems.map((item, index) => {
                    const { itemPdpUrl, itemImageUrl, itemTitle } = item;
                    return (
                        <a
                            key={itemTitle + index}
                            href={itemPdpUrl}
                            className={styles.item}
                            data-tn="recently-viewed-link"
                            onClick={() => this.trackEcommerceProductClick({ item, index })}
                        >
                            <LazyLoad
                                className={styles.lazyImage}
                                offsetHorizontal={HORIZONTAL_OFFSET_RESP_IMG}
                                offsetVertical={VERTICAL_OFFSET_RESP_IMG}
                            >
                                <img
                                    src={itemImageUrl}
                                    alt={itemTitle}
                                    className={styles.image}
                                    data-tn="recently-viewed-image"
                                />
                            </LazyLoad>
                        </a>
                    );
                })}
            </div>
        );
    }
}
